export default __webpack_public_path__ + "static/media/illustrate-document-doc.5ecbbc0d.svg";